import React from 'react';

const StatCard = ({ title, value, icon, trend, color }) => {
  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-icon">{icon}</div>
      <div className="stat-info">
        <h3 className="stat-title">{title}</h3>
        <div className="stat-value">{value}</div>
        {trend && (
          <div className={`stat-trend ${trend > 0 ? 'positive' : trend < 0 ? 'negative' : ''}`}>
            {trend > 0 ? '↑' : trend < 0 ? '↓' : ''}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;